/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Location from './Location';
import TravelCostResponsesInner from './TravelCostResponsesInner';
import UploadedTravelCostNotification from './UploadedTravelCostNotification';
import VehicleType from './VehicleType';

/**
 * The ProcessUploadedTravelCostResponse model module.
 * @module model/ProcessUploadedTravelCostResponse
 * @version 0.0.2
 */
class ProcessUploadedTravelCostResponse {
    /**
     * Constructs a new <code>ProcessUploadedTravelCostResponse</code>.
     * The response schema for processing uploaded travel cost data. This includes the number of entries processed and any errors encountered during the processing.
     * @alias module:model/ProcessUploadedTravelCostResponse
     */
    constructor() { 
        
        ProcessUploadedTravelCostResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProcessUploadedTravelCostResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProcessUploadedTravelCostResponse} obj Optional instance to populate.
     * @return {module:model/ProcessUploadedTravelCostResponse} The populated <code>ProcessUploadedTravelCostResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProcessUploadedTravelCostResponse();

            if (data.hasOwnProperty('travelCostResponses')) {
                obj['travelCostResponses'] = ApiClient.convertToType(data['travelCostResponses'], [TravelCostResponsesInner]);
            }
            if (data.hasOwnProperty('UploadedTravelCostNotifications')) {
                obj['UploadedTravelCostNotifications'] = ApiClient.convertToType(data['UploadedTravelCostNotifications'], [UploadedTravelCostNotification]);
            }
            if (data.hasOwnProperty('NewLocations')) {
                obj['NewLocations'] = ApiClient.convertToType(data['NewLocations'], [Location]);
            }
            if (data.hasOwnProperty('NewVehicleTypes')) {
                obj['NewVehicleTypes'] = ApiClient.convertToType(data['NewVehicleTypes'], [VehicleType]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProcessUploadedTravelCostResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProcessUploadedTravelCostResponse</code>.
     */
    static validateJSON(data) {
        if (data['travelCostResponses']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['travelCostResponses'])) {
                throw new Error("Expected the field `travelCostResponses` to be an array in the JSON data but got " + data['travelCostResponses']);
            }
            // validate the optional field `travelCostResponses` (array)
            for (const item of data['travelCostResponses']) {
                TravelCostResponsesInner.validateJSON(item);
            };
        }
        if (data['UploadedTravelCostNotifications']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['UploadedTravelCostNotifications'])) {
                throw new Error("Expected the field `UploadedTravelCostNotifications` to be an array in the JSON data but got " + data['UploadedTravelCostNotifications']);
            }
            // validate the optional field `UploadedTravelCostNotifications` (array)
            for (const item of data['UploadedTravelCostNotifications']) {
                UploadedTravelCostNotification.validateJSON(item);
            };
        }
        if (data['NewLocations']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['NewLocations'])) {
                throw new Error("Expected the field `NewLocations` to be an array in the JSON data but got " + data['NewLocations']);
            }
            // validate the optional field `NewLocations` (array)
            for (const item of data['NewLocations']) {
                Location.validateJSON(item);
            };
        }
        if (data['NewVehicleTypes']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['NewVehicleTypes'])) {
                throw new Error("Expected the field `NewVehicleTypes` to be an array in the JSON data but got " + data['NewVehicleTypes']);
            }
            // validate the optional field `NewVehicleTypes` (array)
            for (const item of data['NewVehicleTypes']) {
                VehicleType.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * This schema defines the response for travel costs between pairs of locations.
 * @member {Array.<module:model/TravelCostResponsesInner>} travelCostResponses
 */
ProcessUploadedTravelCostResponse.prototype['travelCostResponses'] = undefined;

/**
 * A list of notifications about the processing of the uploaded travel cost data. Each notification provides information about the processing status of each entry.
 * @member {Array.<module:model/UploadedTravelCostNotification>} UploadedTravelCostNotifications
 */
ProcessUploadedTravelCostResponse.prototype['UploadedTravelCostNotifications'] = undefined;

/**
 * A list of new locations that were added to the system as a result of processing the uploaded travel cost data.
 * @member {Array.<module:model/Location>} NewLocations
 */
ProcessUploadedTravelCostResponse.prototype['NewLocations'] = undefined;

/**
 * A list of new vehicle types that were added to the system as a result of processing the uploaded travel cost data.
 * @member {Array.<module:model/VehicleType>} NewVehicleTypes
 */
ProcessUploadedTravelCostResponse.prototype['NewVehicleTypes'] = undefined;






export default ProcessUploadedTravelCostResponse;

